import React, {useRef} from 'react';
import gql from 'graphql-tag';
import Survey from '../survey/Survey';
import PropTypes from 'prop-types';

const CatalogInquiryForm = props => {

  let {
    viewer,
    documentId,
    readOnly,
  } = props;

  let dynamicForm = useRef(null);

  const validate = () => {
    return dynamicForm.current.validate();
  };

  const reset = () => {
    return dynamicForm.current.reset();
  };

  const afterSubmit = (data) => {
    console.log('afterSubmit', data);
  }

  return (
    <>
      <Survey leadType={'DOWNLOAD_CATALOG'}
              relatedIds={[documentId]}
              showUserInfo={true}
              viewer={viewer}
              afterSubmit={afterSubmit}
       />
    </>
  )

};

CatalogInquiryForm.fragment = {
  viewer: gql`
      fragment CatalogInquiryForm_viewer on Viewer {
          ...Survey_viewer
      }
    ${Survey.fragments.viewer}
  `
};

CatalogInquiryForm.propTypes = {
  readOnly: PropTypes.bool,
};

export default CatalogInquiryForm;
